/*
* Ajax functionality used for Antenne Player on vol.at hp
*
*/

(function(window, document, undefined) {
  'use strict';
  const $ = window.jQuery,
    console = window.console || {log: function() { }};
  let ticker = $('.vodl-antenne-vlbg.pre-init');

  /**
   * init everything
   */
  function init_ticker() {

    load();

    window.setInterval(function() {
      load();
    }, 30 * 1000);

    ticker.removeClass('pre-init');
  }

  /**
	 * Initialization handled by event listener for newPage event.
	 */
  function event_handled_init() {

    ticker = $('.vodl-antenne-vlbg.pre-init');

    // If nothing was found - do nothing :)
    if (ticker.length > 0) {

      init_ticker();

      // Remove init_ticker function from newPage event ( we assume there's only one widget per page ).
      window.removeEventListener('newPage', event_handled_init, false);
    }
  }

  /**
   * Loads the artist, title and cover into the player.
   *
   * Makes an ajax call to the configured src URL and applies the response text to the said node.
   *
   */
  function load() {
    $.ajax({
      url: 'https://antenneplayer.vol.at/live.php',
      async: true,
      dataType: 'json'
    }).then(
      function(obj) {
        var artist = obj.artist,
          title = obj.title || '',
          cover = obj.coverUrl || '';

        $('.vodl-antenne-vlbg__artist').text(artist);
        $('.vodl-antenne-vlbg__title').text(title);

        var img = $('.vodl-antenne-vlbg__cover'),
          src = 'https://antenneplayer.vol.at/live.jpg', // stream logo for mainstream
          playButton = $('.vodl-antenne-vlbg_play-button'),
          playButtonHover = $('.vodl-antenne-vlbg_play-button-hover');

        if (cover) {
          src = cover;
        }

        $('.vodl-antenne-vlbg__body').css('background-image', 'url("' + src + '")');
        img.attr('src', src);

        playButton.mouseover(function() {
          playButtonHover.addClass('vodl-antenne-vlbg--show');
          playButton.addClass('vodl-antenne-vlbg--hide');
        });

        playButtonHover.mouseleave(function() {
          playButtonHover.removeClass('vodl-antenne-vlbg--show');
          playButton.removeClass('vodl-antenne-vlbg--hide');
        });

      }, function(xhr, status, error) {
        console.log('antenne ticker: error ocurred');
      }
    );
  }

  $(document).ready(function() {

    // Do the stuff only when ticker is already there and wasn't initialized, yet.
    if (ticker.length > 0) {

      init_ticker();

    } else  { // otherwise wait for newPage event and check again

      // Initialize event listener for lazy antenne ticker.
      window.addEventListener('newPage', event_handled_init, false);
    }
  });

})(window, document);
